import EditIcon from '@mui/icons-material/Edit';
import HouseIcon from "@mui/icons-material/House";
import BedIcon from "@mui/icons-material/Bed";
import Logout from "@mui/icons-material/Logout";
import MailIcon from "@mui/icons-material/Mail";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Person from "@mui/icons-material/Person";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../Auth";
import { Badge } from '@mui/material';
import { hasAccessToHouse } from '../../utils/adminutils';
import { HouseName } from '../../ostertalertypes';

export default function AccountMenu() {
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = () => {
    auth.logout();
    navigate("/");
  };

  const getAccountSettingsLetters = ():string => {
    if (auth.userDetails)
      return auth.userDetails.firstname.charAt(0).toUpperCase() + auth.userDetails.lastname.charAt(0).toUpperCase();
    else {
      return "M";
    }
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account Einstellungen">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>{getAccountSettingsLetters()}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem component={Link} to="/profil">
            <ListItemIcon>
              <Avatar/>
            </ListItemIcon>
            Mein Profil
        </MenuItem>
        <Divider/>
        {auth.isAdmin() && (
          <div>
            <MenuItem component={Link} to="/benutzer/erstellen">
              <ListItemIcon>
                <PersonAdd fontSize="small" />
              </ListItemIcon>
              Benutzer anlegen
            </MenuItem>
            <MenuItem component={Link} to="/benutzer/verwalten">
              <ListItemIcon>
                <Person fontSize="small" />
              </ListItemIcon>
              Benutzer verwalten
            </MenuItem>
            <MenuItem component={Link} to="/buchung/erstellen">
              <ListItemIcon>
                <BedIcon fontSize="small"/>
              </ListItemIcon>
              Buchung eintragen
            </MenuItem>
            <MenuItem component={Link} to="/buchung/bearbeiten">
              <ListItemIcon>
                <EditIcon fontSize="small"/>
              </ListItemIcon>
              Buchung ändern
            </MenuItem>
            <MenuItem component={Link} to="/buchung/status">
              <ListItemIcon>
                <Badge badgeContent={auth.countIncomingBookings} color="primary">
                  <MailIcon color="action" fontSize="small" />
                </Badge>
              </ListItemIcon>
              Buchungsanfragen
            </MenuItem>
            <MenuItem component={Link} to="/auslastung">
              <ListItemIcon>
                <HouseIcon fontSize="small"/>
              </ListItemIcon>
              Auslastung
            </MenuItem>
            { hasAccessToHouse(auth.adminHouses, HouseName.Biberwier) && (
              <MenuItem component={Link} to="/einstellungen">
                <ListItemIcon>
                  <SettingsIcon fontSize="small"/>
                </ListItemIcon>
                Einstellungen
              </MenuItem>
            )}
          </div>
        )}
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
